import React, { useState, useCallback } from "react";
import { Modal, Icon, notification } from "antd";

import { getAuthorization } from "@arachnys/flow-app/src/api";

const FileDeletePopup = ({ refetch, requestId, docstoreId }) => {
    const [visible, setVisible] = useState(false);

    const onClose = useCallback(() => {
        setVisible(false);
    }, [setVisible]);

    const handleDelete = useCallback(async () => {
        const auth = await getAuthorization();

        const request = new Request(
            `/api/tickets/bulk_upload_request/${requestId}/file_upload/${docstoreId}/`,
            {
                method: "DELETE",
                headers: {
                    Authorization: auth,
                },
            }
        );
        const response = await fetch(request);

        if (response.ok) {
            notification.success({
                message: "Deletion Success",
                description: "File uploaded successfully",
            });
            refetch();
            onClose();
        } else {
            notification.error({
                message: "Deletion error",
                description:
                    "File delete failed! Please, check your connection or permissions!",
            });
        }

        onClose();
    }, [refetch, requestId, docstoreId, onClose]);

    return (
        <>
            <Icon type="delete" onClick={() => setVisible(true)} />
            <Modal
                visible={visible}
                onCancel={onClose}
                onOk={handleDelete}
                okText="Delete"
                title="Delete File"
            >
                Are you sure want to delete this file?
            </Modal>
        </>
    );
};

export default FileDeletePopup;
